import {DetailedHTMLProps, HTMLProps, ReactElement, ReactNode} from "react"
import {pair} from "@/library/types/pair"
import {classNames} from "@/library/utilities/html"

type ButtonProps = {
    type?: 'button' | 'submit' | 'reset'
    size?: 'size-s' | 'size-m' | 'size-l' | 'size-xs' | 'size-xl'
    color?: 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'error' | 'info'
    outline?: boolean
    disabled?: boolean
    text?: string | ReactNode | ReactElement
    unStyled?: boolean
    children?: ReactNode[] | ReactNode
} & DetailedHTMLProps<HTMLProps<HTMLButtonElement>, HTMLButtonElement>

export default function Button(props: ButtonProps) {
    const {
        className = '',
        type = 'button',
        size = 'size-m',
        color = 'default',
        outline = false,
        disabled = false,
        text,
        unStyled = false,
        children,
        ...buttonProps
    } = props

    return <button {...buttonProps}
                   className={classNames(
                       size,
                       color,
                       pair('outline', outline),
                       pair('no-styles', unStyled),
                       className
                   )}
                   disabled={disabled}
                   type={type}
    >{children ?? text}</button>
}
